import type { FC } from 'react';
import { useState } from 'react';
import { ConfirmationModal } from '@components/ConfirmationModal';

interface ConfirmBrandingStatusModalProps {
  handleClose: () => void;
  onConfirm: (status: string) => Promise<void>;
  status: string;
}

const ConfirmBrandingStatusModal: FC<ConfirmBrandingStatusModalProps> = ({ handleClose, onConfirm, status }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm(status);
    setIsLoading(false);
    handleClose();
  };

  return (
    <ConfirmationModal
      confirmLabel="Yes, finalise branding"
      description="By setting this branding to published it will become available for users when creating new templates and submissions."
      icon="valid"
      isLoading={isLoading}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Ready to finalise branding?"
    />
  );
};

export default ConfirmBrandingStatusModal;
